import moment from 'moment-jalaali';
const toPersian = value => {
    const charCodeZero = '۰'.charCodeAt(0);
    if (value === null || value === undefined ) {
        return ' - ';
    } else {
        return String(value).replace(/[0-9]/g, w =>
            String.fromCharCode(w.charCodeAt(0) + charCodeZero - 48)
        );
    }
};
const numbers = {
    putCommas: number => {
        if (typeof number === 'undefined') return number;
        if (typeof number === 'number') number = number.toString();
        return number.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    toEnglishDigits: value => {
        const charCodeZero = '۰'.charCodeAt(0);
        return value.replace(/[۰-۹]/g, w => w.charCodeAt(0) - charCodeZero);
    },
    toPersianDigits: value => {
        return toPersian(value);
    },
    toTime: seconds => {
        let temp = seconds;
        let string = '';
        let c;
        while (temp) {
            c = ('0' + (temp % 60)).slice(-2);
            temp = Math.floor(temp / 60);
            string = `${c}:${string}`;
        }
        if (string) return toPersian(string.slice(0, -1));
        return 0;
    },
    dateshamsi: date => {
        if (date !== undefined) {
            let sham = [
                date.split('T', 2)[0],
                date.split('T', 2)[1].split('+', 2)[0],
                date.split('T', 2)[1].split('+', 2)[1]
            ];
            
            let stsham = sham[0] + '  ' + sham[1];
            return moment(stsham, 'YYYY-M-D HH:mm:ss')
                .add(4, 'hour')
                .add(30, 'minute')
                .format('jYYYY/jM/jD HH:mm:ss');
        }
        // date.split("T", 2)
        //var time=arr[1].split(".", 2);
    },chunkArray: (myArray, chunk_size) => {
        var index = 0;
        var arrayLength = myArray.length;
        var tempArray = [];

        for (index = 0; index < arrayLength; index += chunk_size) {
            const myChunk = myArray.slice(index, index + chunk_size);

            // Do something if you want with the group
            // min=myChunk.filter(item => item.tmin_p!== 0 )
            // max=myChunk.filter(item => item.tmax_p!== 0 )
            //tempArray.push(min,max);
            const min = myChunk[4].tmin_p;
            const max = myChunk[0].tmax_p;
            const  rain = myChunk[5].rrr24_p;
            const dpoint=myChunk[5].dpt_p;
            const  wind=myChunk[5].ff_p;
            const temp=myChunk[5].t2m_p;
            const date = moment.unix(myChunk[0].forecast_date / 1000).format('jM/jD');
            tempArray.push({
                key: index / chunk_size,
                min: min,
                max: max,
                rain: rain,
                date: date,
                dpoint:dpoint,
                wind:wind,
                temp:temp
            });
        }

        return tempArray;
    },
    heatIndex:(t,rh )=> {
        const far=1.8*t+32;
       let temp= -42.379+(2.04901523*far)+(10.14333127*rh)-(0.22475541*far*rh)
        -(6.83783*0.001*far*far)-(5.481717*0.01*rh*rh)+(1.22874*0.001*far*far*rh)
        +(8.5258*0.0001*far*rh*rh)-(1.99*0.000001*far*far*rh*rh);

     return (temp-32)/1.8;
    },
};

export { numbers };
